import React, {useEffect} from "react";
import { DollarOutlined, CheckCircleOutlined, IssuesCloseOutlined, StopOutlined } from '@ant-design/icons';
import { Avatar, Card, Flex, Switch, Table } from 'antd';
import OrderDetailUser from "./OrderDetailUser";
import EntityApi from "../../api/EntityApi";
import { Pagination } from "antd";

const OrdersUser = ({userId}) => {

    const [items, setItems] = React.useState([]);
    const [reload, setReload] = React.useState(true);
    const [total, setTotal] = React.useState(0);
    const [page, setPage] = React.useState(1);
    const [pageSize, setPageSize] = React.useState(5);

    const getList = (page = 1) => {
        EntityApi.getBy('private/order', {
            filter: {
                user_id: userId
            },
            page: page,
            size: pageSize
        }).then((data) => {
            if (data.status === EntityApi.STATUS_SUCCESS) {
                let orders = [];
                if (data.content.items) {
                    data.content.items.forEach((item) => {
                        let order = {
                            id: item.id,
                            price: item.price,
                            dt: item.dt,
                            is_payment: item.is_payment,
                            payment_dt: item.payment_dt,
                            is_cancelled: item.is_cancelled,
                            cart: []
                        };
                        item.cart.forEach((cartItem) => {
                            order.cart.push({
                                key: cartItem.id,
                                code: cartItem.entity_code,
                                name: cartItem.name,
                                price: cartItem.price,
                                access: cartItem.access_text,
                            });
                        })
                        orders.push(order);
                    });
                }
                setItems(orders);
                setTotal(data.payload.total);
                setPage(data.payload.currentPage);
            }
        });
    }

    const onPaginate = (page) => {
        getList(page);
    }

    useEffect(() => {
        setItems([]);
        getList();
    }, [reload]);

    return <>
        <div
            className="flex flex-col items-center space-y-4 border-b border-slate-200 p-4 dark:border-navy-500 sm:flex-row sm:justify-between sm:space-y-0 sm:px-5">
            <h2 className="text-lg font-medium tracking-wide text-slate-700 dark:text-navy-100">
                Заказы пользователя
            </h2>
        </div>
        <div className="p-4 sm:p-5">
            <div className="is-scrollbar-hidden min-w-full overflow-x-auto">
                {
                    items.map((item) => <OrderDetailUser key={item.id} reload={() => setReload(!reload)} item={item}/>)
                }
                <div className={"pt-4"}>
                    <Pagination defaultCurrent={page} pageSize={pageSize} onChange={onPaginate} total={total} />
                </div>
            </div>
        </div>
    </>

}

export default OrdersUser;
